import { useStyleSheet } from '../../../hooks/useStyleSheet';
import { PageLayoutProps } from './PageLayout.types';

export const useStyles = ({
  header,
  topic,
  subTopic,
  styles: customStyles,
}: Pick<PageLayoutProps, 'header' | 'topic' | 'styles' | 'subTopic'>) => {
  const styles = useStyleSheet(
    (theme) => {
      const headerTemplateRow = header ? '2.5rem' : '';
      const topicTemplateRow = topic ? '4rem' : '';
      const subTopicTemplateRow = subTopic ? 'auto' : '';

      const hideScrollbar = {
        '::-webkit-scrollbar': {
          display: 'none',
        },
      };

      return {
        root: {
          height: '100vh',
          display: 'grid',
          gap: theme.spacing.primary,
          gridTemplateRows: `${headerTemplateRow} ${topicTemplateRow} ${subTopicTemplateRow} minmax(0, 1fr) 1rem`,
          [theme.breakPoints.down('lg')]: {
            gridTemplateRows: `${headerTemplateRow} auto ${subTopicTemplateRow} minmax(0, 1fr) 1rem`,
          },
          ...customStyles?.root,
        },
        header: {
          position: 'relative',
        },
        topic: {
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          gap: theme.spacing.primary,
          background: theme.palette.background.secondary,
          padding: theme.spacing.primary,
          borderRadius: theme.borderRadius.md,
          ...customStyles?.topic,
        },
        subTopic: {
          padding: `0 ${theme.spacing.primary}`,
        },
        topicTagContainer: {
          position: 'relative',
          top: theme.spacing.calc(-0.6),
          ...customStyles?.topicTag,
        },
        content: {
          display: 'grid',
          position: 'relative',
          gridTemplateColumns: 'minmax(0, 100%) 1fr',
          gridTemplateRows: '1fr minmax(0, 100%)',
        },
        contentHeader: {
          padding: `0 ${theme.spacing.primary}`,
        },
        contentAside: {
          gridColumn: 2 / -1,
          gridRow: 2 / -1,
          display: 'grid',
          paddingTop: theme.spacing.primary,
        },
        contentBody: {
          position: 'relative',
          zIndex: 1,
          gridColumn: 1 / 2,
          gridRow: 2 / -1,
          background: theme.palette.background.secondary,
          padding: theme.spacing.primary,
          borderRadius: theme.borderRadius.md,
          overflow: 'auto',
          ...hideScrollbar,
        },
      };
    },
    [header, topic, subTopic],
  );

  return styles;
};
